<div class="adjust-image-box">
  <div class="header">
    <h3 class="semibold">Adjust image</h3>
    <img (click)="close()" [src]="iconService.Icon.cross" />
  </div>
  @if (!isLoading) {
    <div class="image-black-box" #blackBox (wheel)="onWheel($event)" (mousedown)="onBlackBoxMouseDown($event)">
      <img
        #imageElement
        class="img"
        [src]="imageSrc"
        [style.width.px]="imgWidth"
        [style.min-width.px]="imgWidth"
        [style.height.px]="imgHeight"
        [style.transform]="imgTransform"
        [style.cursor]="imageFit === 'Fill' || imageFit === 'Crop' ? (isFillDragging || isCropPanning ? 'grabbing' : 'grab') : 'default'"
        (mousedown)="onImageMouseDown($event)" />

      <div class="shown-area-overlay" [style.clip-path]="overlayClipPath"></div>

      <div class="shown-area" #shownArea [style.width.px]="hasPadding ? shownAreaWidth + scaledPaddingLeft + scaledPaddingRight : shownAreaWidth" [style.height.px]="hasPadding ? shownAreaHeight + scaledPaddingTop + scaledPaddingBottom : shownAreaHeight"></div>

      @if (hasPadding) {
        <div class="padding-overlay" [style.width.px]="shownAreaWidth + scaledPaddingLeft + scaledPaddingRight" [style.height.px]="shownAreaHeight + scaledPaddingTop + scaledPaddingBottom" [style.clip-path]="paddingClipPath"></div>
      }

      @if (imageFit === "Crop") {
        <div class="crop-box" [style.left.px]="screenCropLeft" [style.top.px]="screenCropTop" [style.width.px]="cropBox.w" [style.height.px]="cropBox.h" (mousedown)="onCropBoxDown($event)">
          <div class="crop-handle crop-handle--top" (mousedown)="onCropHandleDown($event, 'top')"></div>
          <div class="crop-handle crop-handle--bottom" (mousedown)="onCropHandleDown($event, 'bottom')"></div>
          <div class="crop-handle crop-handle--left" (mousedown)="onCropHandleDown($event, 'left')"></div>
          <div class="crop-handle crop-handle--right" (mousedown)="onCropHandleDown($event, 'right')"></div>
          <div class="crop-handle crop-handle--topleft" (mousedown)="onCropHandleDown($event, 'topleft')"></div>
          <div class="crop-handle crop-handle--topright" (mousedown)="onCropHandleDown($event, 'topright')"></div>
          <div class="crop-handle crop-handle--bottomleft" (mousedown)="onCropHandleDown($event, 'bottomleft')"></div>
          <div class="crop-handle crop-handle--bottomright" (mousedown)="onCropHandleDown($event, 'bottomright')"></div>
        </div>
      }
    </div>

    <bar-loader height="3px" [isLoading]="uploading" [greyBarWhenNotLoading]="false"></bar-loader>

    <div class="flex-row" style="justify-content: center; width: 100%; padding: 16px 0">
      <ag-toggle-button option1="Original" option2="Fill" option3="Crop" [numberOfOptions]="3" [initValue]="imageFit" [initEmit]="false" (chosenOption)="onImageFitChange($event)"></ag-toggle-button>
    </div>
  }

  <div class="footer">
    <ag-button-v2 type="tertiary" label="Cancel" size="large" (click)="close()"></ag-button-v2>
    <ag-button-v2 label="Save" size="large" specificWidth="184px" (click)="save()"></ag-button-v2>
  </div>

  <div class="legend">
    <div class="legend-item">
      <div class="legend-line legend-line--solid"></div>
      <span>Image area</span>
    </div>
    @if (hasPadding) {
      <div class="legend-item">
        <div class="padding-legend"></div>
        <span>Padding</span>
      </div>
    }
    @if (imageFit === "Crop") {
      <div class="legend-item">
        <div class="legend-line legend-line--crop"></div>
        <span>Crop area</span>
      </div>
    }
  </div>
</div>
